<template>
    <app-dialog :value="value" size="lg" @input="$emit('input', $event)">
        <template #header>
            <h2 class="text-lg font-semibold text-theme-base">
                ¿Cómo elegir tu plan?
            </h2>
            <p class="mt-1 text-sm text-theme-muted">
                No hace falta comparar todo. Busca la etapa en la que estás y
                ahí está tu plan.
            </p>
        </template>

        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div
                v-for="stage in stages"
                :key="stage.code"
                class="flex flex-col rounded-xl border border-theme-border bg-theme-card p-5"
            >
                <span class="text-2xl">{{ stage.emoji }}</span>
                <h3 class="font-semibold text-theme-base mt-3">
                    {{ stage.title }}
                </h3>
                <p class="text-sm text-theme-muted mt-1.5 flex-1">
                    {{ stage.desc }}
                </p>
                <p
                    class="text-sm font-medium mt-3"
                    :class="accentClass(stage.code)"
                >
                    → Plan {{ planName(stage.code) }}
                </p>
            </div>
        </div>
    </app-dialog>
</template>

<script>
import { TIER_ACCENT_CLASSES } from "@/common/fields/plan-content";

import AppDialog from "@/components/utils/AppDialog.vue";

// Mismo texto que PlanGuideSection.vue en el landing (repos/landing/app/
// components/landing/PlanGuideSection.vue): ayuda al cliente a identificarse
// con una etapa de su negocio en vez de comparar cupos y precios de una.
const STAGES = [
    {
        emoji: "👤",
        title: "Empiezas, y vendes contacto",
        desc: "Un creador que vende talleres o experiencias, un profesional al que solo le tienen que agendar. Tu foto, tus redes, tus colores y cinco enlaces. Gratis para siempre.",
        code: "free"
    },
    {
        emoji: "🏪",
        title: "Tienes pocos productos, o quieres tu página más tuya",
        desc: "Un negocio pequeño con pocas referencias, o un profesional que quiere armar su página con bloques. Ya registras ventas y clientes y mandas cotizaciones en PDF.",
        code: "starter"
    },
    {
        emoji: "🛒",
        title: "Quieres que tu link venda",
        desc: "Tu catálogo funciona como tienda: recibes pedidos, activas medios de pago y tienes tu URL propia para dar confianza.",
        code: "pro"
    },
    {
        emoji: "🏢",
        title: "Tu operación vive en la plataforma",
        desc: "Varias sedes, inventario, más personal, muchas referencias y muchas órdenes al mes.",
        code: "premium"
    }
];

export default {
    name: "PlanGuideModal",

    components: { AppDialog },

    props: {
        value: {
            type: Boolean,
            required: true
        },
        plans: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return { stages: STAGES };
    },

    methods: {
        accentClass(code) {
            const accent = TIER_ACCENT_CLASSES[code];
            return accent ? accent.text : "text-theme-primary";
        },
        planName(code) {
            const plan = this.plans.find((item) => item.code === code);
            return plan ? plan.name : code;
        }
    }
};
</script>
